import { carePlanRequestsTyped } from "@/api/(requests)/carePlanTyped";
import type { GoalAndObjectiveTextResponse } from "@/core/types";

export async function getGoalAndObjectiveText(
  patientId: string,
): Promise<GoalAndObjectiveTextResponse> {
  return carePlanRequestsTyped.get_goal_and_objective_text({
    context: { showLoader: false },
    patientId,
  });
}
